/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/


// TODO create reusable Icon component with size property
const BlackDuckIcon = () => {
  return (
    <img
      src="/icons/blackduck-logo.png"
      alt="BlackDuck icon"
      style={{ height: '14px', width: '14px' }}
    />
  );
};

export default BlackDuckIcon;
